import { Button, Form, Input, Modal, Spin, Upload, message, Image, Avatar } from "antd";
import { useEffect, useState } from "react";
import { FaUpload } from "react-icons/fa";
import axios from "axios";
import { MdDelete } from "react-icons/md";

import { baseUrl, fileUrl } from "../constants/const";

const AddTipModal = ({ open, isEdit = false, selectedtip, onCancel, onSuccess }) => {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [mediaType, setMediaType] = useState('');
    const [mediaUrl, setMediaUrl] = useState('');
    const [uploading, setUploading] = useState(false);
    const [adding, setAdding] = useState(false);
    console.log('selectedtip', selectedtip)

    /* =======================
       Upload to backend
    ======================= */
    const uploadFileToServer = async (file) => {
        const formData = new FormData();
        formData.append("media", file);

        setUploading(true);
        try {
            const res = await axios.post(
                `${baseUrl}/auth/upload-media`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            const url = res?.data?.data?.media_link;
            if (!url) throw new Error("Invalid upload response");

            let type = "image";
            if (file.type.startsWith("video/")) type = "video";
            if (file.type.startsWith("audio/")) type = "audio";

            setMediaUrl(url);
            setMediaType(type);

            setFileList([
                {
                    uid: "-1",
                    name: file.name,
                    status: "done",
                    url: `${fileUrl}${url}`,
                    type: file.type,
                },
            ]);
        } catch {
            message.error("Upload failed");
            handleRemove();
        } finally {
            setUploading(false);
        }
    };


    /* =======================
       Upload handlers
    ======================= */
    const beforeUpload = async (file) => {
        const isImage = file.type.startsWith("image/");
        const isVideo = file.type.startsWith("video/");
        const isAudio = file.type.startsWith("audio/");

        if (!isImage && !isVideo && !isAudio) {
            message.error("Only image, video or audio files are allowed");
            return Upload.LIST_IGNORE;
        }

        if (isImage) setMediaType("image");
        if (isVideo) setMediaType("video");
        if (isAudio) setMediaType("audio");

        await uploadFileToServer(file);
        return false; // stop auto upload
    };



    const handleRemove = () => {
        setFileList([]);
        setMediaUrl();
        setMediaType(null);
        return true;
    };

    /* =======================
       Submit
    ======================= */
    const handleFinish = async (values) => {
        const payload = {
            tips: values.tips,
            information: values.information,
            media_type: mediaType || '',
            media_url: mediaUrl || '',
            ...(selectedtip?._id && { _id: selectedtip._id }),
        };

        try {
            setAdding(true);

            const apiUrl = selectedtip?._id
                ? `${baseUrl}/admin/update_tips`
                : `${baseUrl}/admin/add_tips`;

            const res = isEdit
                ? await axios.put(apiUrl, payload)
                : await axios.post(apiUrl, payload);

            // ✅ ensure backend confirms success
            if (res) {
                message.success(selectedtip?._id ? "Tip updated" : "Tip added");

                // 🔥 call after confirmed success
                onSuccess?.();
                handleClose();
            } else {
                message.error("Update failed");
            }
        } catch (err) {
            message.error("Something went wrong");
        } finally {
            setAdding(false);
        }
    };



    const handleClose = () => {
        form.resetFields();
        setFileList([]);
        setMediaType(null);
        setMediaUrl(null);
        onCancel();
    };


    useEffect(() => {
        if (selectedtip && isEdit) {
            form.setFieldsValue({
                tips: selectedtip?.tips,
                information: selectedtip?.information,
            });

            if (selectedtip?.media_url) {
                setMediaUrl(selectedtip?.media_url);
                setMediaType(selectedtip?.media_type);

                setFileList([
                    {
                        uid: "-1",
                        name: "media",
                        status: "done",
                        url: fileUrl + selectedtip?.media_url,
                        type: selectedtip?.media_type === "image" ? "image/*" : "video/*",
                    },
                ]);
            }
        }
    }, [selectedtip, form]);

    return (
        <Modal
            title={isEdit ? "Update Tip" : "Add Tip"}
            open={open}
            onCancel={handleClose}
            footer={null}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                {/* Upload */}
                <Form.Item label="Upload Media" style={{ textAlign: "center" }}>
                    <Upload
                        listType="picture-card"
                        fileList={fileList}
                        beforeUpload={beforeUpload}
                        onRemove={handleRemove}
                        showUploadList={false}
                    >
                        {fileList.length > 0 ? (
                            <div
                                style={{ width: 104, height: 80, position: "relative", borderRadius: 8, display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: "hidden", background: "#ffffff" }}
                            >
                                {/* 🎥 Video Preview */}
                                {mediaType === "video" ?
                                    <video
                                        src={fileList[0]?.url}   // ✅ backend URL
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                        muted
                                        autoPlay
                                    /> :
                                    mediaType === 'audio' ?
                                        <audio
                                            src={fileList[0]?.url}
                                            controls
                                            style={{ width: "100%" }}
                                        />
                                        :
                                        <div className="bg-white  ">
                                            <Avatar src={fileUrl + mediaUrl} />
                                        </div>

                                }
                                {/* ❌ Delete */}
                                <div
                                    onClick={handleRemove}
                                    style={{
                                        position: "absolute",
                                        top: 6,
                                        right: 6,
                                        background: "rgba(0,0,0,0.6)",
                                        borderRadius: "50%",
                                        width: 22,
                                        height: 22,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                    }}
                                >
                                    <MdDelete className="text-white bg-red" />
                                </div>

                            </div>
                        )

                            : (
                                fileList.length === 0 && (
                                    <div className="flex flex-col items-center gap-2">
                                        {uploading ? <Spin /> : <>
                                            <FaUpload />
                                            <span className="text-xs">Upload</span>
                                        </>}
                                    </div>
                                )
                            )}
                    </Upload>


                </Form.Item>

                <Form.Item
                    label="Tips"
                    name="tips"
                    rules={[{ required: true, message: "Please enter tip" }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Information"
                    name="information"
                    rules={[{ required: false, message: "Please enter information" }]}
                >
                    <Input.TextArea rows={3} />
                </Form.Item>

                <Button type="primary" htmlType="submit" block loading={adding}>
                    {isEdit ? "Update Tip" : "Add Tip"}
                </Button>
            </Form>
        </Modal>
    );
};

export default AddTipModal;
